<div class="main-div">
  @if ($companyChange | async) {
  }
  <ng-container *ngrxLet="$widgetData; let widgetData; suspenseTpl: loading">
    @if (hasValues(settlementCards)) {
      <app-bubble-chart [currencyOverviews]="widgetData[0].currencyOverviews"
                        [selectedCcy]="selectedSymbol"
                        [baseCurrency]="widgetData[1]"
                        (selectedCcyChange)="onCcyChange($event)" />
    } @else {
      <div class="d-flex justify-content-center">
        <ion-icon src="assets/icon/empty-bubble-chart.svg" class="empty-bubble-chart"/>
      </div>
    }
    @if (hasValues(settlementCards)) {
      <ion-row class="ion-justify-content-between">
        <ion-col size="6">
          <div class="subtitle">
            {{ 'insights.labels.net-settlements' | translate }}
          </div>
        </ion-col>
        <ion-col size="6">
          <ion-row>
            <span class="settlement-date-label">{{ 'insights.labels.settlement' | translate }}</span>
          </ion-row>
          <ion-row>
            <span class="date">{{ datesLabel }}</span>
          </ion-row>
        </ion-col>
      </ion-row>
    }
    @if (hasValues(settlementCards)) {
      <ion-content class="scroll-container"
                   [scrollEvents]="true"
                   [scrollY]="true">
        @for (settlementCard of settlementCards; track settlementCard) {
          <app-bubble-chart-card class="chart-card"
                                 [id]="settlementCard.currency"
                                 [settlementCard]="settlementCard"
                                 [selected]="settlementCard.currency === selectedSymbol"
                                 (click)="toggleSelectedCard(settlementCard.currency === selectedSymbol
                                   ? null
                                   : settlementCard.currency)"
                                 (selectSymbol)="goToDetails(settlementCard.currency)" />
        }
      </ion-content>
    } @else {
      <div class="no-trades-message ion-text-center">{{ 'insights.no-settlements' | translate }}</div>
    }
  </ng-container>
</div>
<ng-template #loading>
  <ion-spinner name="crescent"/>
</ng-template>

